// extracted by css-extract-rspack-plugin
export default {"container":"LeadingVisual-module__container__geyAv","hasNewActivity":"LeadingVisual-module__hasNewActivity__BRL3Q","visualContainer":"LeadingVisual-module__visualContainer__eYlkW"};